<template>
  <v-container fluid pa-0 ma-0 fill-height>
    <v-layout row wrap class="ma-0" fill-height>

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">{{ page.title }}</h3>
      </v-toolbar>

      <v-flex xs12 class="mt-2">
        <v-card tile flat class="card-shadow px-3 pt-4 pb-2" style="height: 100%">
          <v-card-text class="pt-0 pb-4">
            <h1 class="display-4 mb-2" v-if="typeof page.subtitle !== 'undefined'">{{ page.subtitle }}</h1>
            <span style="font-size: 14px; letter-spacing: -0.3px; color: #9b9b9b;" v-html="page.content"></span>
          </v-card-text>

          <div class="px-1">
            <v-form v-model="valid">
              <v-text-field label="이메일 주소"
                            required
                            class="mb-3"
                            :rules="rules.email"
                            placeholder="이메일 주소"
                            v-model="senderEmail">
              </v-text-field>
              <v-textarea label="내용"
                          required
                          :rules="rules.content"
                          placeholder="내용을 입력하세요."
                          no-resize
                          rows="10"
                          counter="500"
                          v-model="content">
              </v-textarea>
            </v-form>
          </div>

          <div class="mt-3" style="display: flex; align-items: center; height: 42px;" v-if="$route.name !== 'RefundRequest'">
            <input ref="imgUpload" name="img-uploads" type="file" accept="image/*"
                   @change="onFileChanged" style="display: none;">
            <v-text-field hide-detail placeholder="선택된 파일 없음" v-model="files.name"
                          @click.stop="$refs.imgUpload.click()" readonly
                          :append-icon="files.name ? $vuetify.icons.cancelRound : ''"
                          @click:append="deleteFile()"></v-text-field>
            <v-btn depressed color="#f8f8f8" class="ma-0 ml-3" style="height: 100%;" @click="$refs.imgUpload.click()">
              이미지 첨부
            </v-btn>
          </div>

          <div class="px-3 pt-5 pb-5">
            <v-btn :disabled="!valid"
                   :loading="loading"
                   block depressed color="#4a4a4a"
                   class="button-style"
                   style="color: white !important;"
                   @click="submit">
              {{ page.title }}
            </v-btn>
          </div>
        </v-card>
      </v-flex>

      <!-- 임시 스낵바 -->
      <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
        {{ snackbarMessage }}
        <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
      </v-snackbar>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'EmailForm',
    props: [ 'paymentIdx' ],
    computed: {
      ...mapGetters('user', [ 'email' ]),
      page () {
        switch (this.$route.name) {
          case 'Suggestion':
            return {
              title: '제안하기',
              subtitle: '유스에게 의견을 들려주세요!',
              content: '앱 개선 제안, 버그 제보 등<br>다양한 의견을 기다리고 있습니다.',
            };
          case 'Inquiry':
            return {
              title: '문의하기',
              content: '문의하실 사항을 적어주세요.<br>확인 후 이메일로 답변드리겠습니다.',
            };
          case 'RefundRequest':
            return {
              title: '구매 취소 및 환불 요청',
              content: '구매 취소 및 환불 사유를 적어주세요.<br>확인 후 처리해드리겠습니다.',
            };
          default:
            return;
        }
      }
    },
    data () {
      return {
        scrollY: 0,
        loading: false,
        valid: false,
        senderEmail: '',
        content: '',
        files: { name: '', url: null, file: null },
        rules: {
          email: [
            v => !!v || '이메일을 입력하세요.',
            v => /.+@.+/.test(v) || '유효하지 않은 메일 주소입니다.',
          ],
          content: [
            v => !!v || '내용을 입력하세요.',
            v => v.length <= 500 || '500자를 초과할 수 없습니다.',
          ]
        },
        snackbar: false,
        snackbarMessage: '',
        leave: false,
      };
    },
    created () {
      this.senderEmail = this.email;
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      snackbar (flag) {
        if (!flag && this.leave) this.$router.go(-1);
      }
    },
    methods: {
      ...mapActions('product', [ 'requestPaymentCancel' ]),
      ...mapActions([ 'sendMail' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
      },
      submit () {
        if (!this.valid) return false;
        this.loading = true;
        let formData = new FormData();
        switch (this.$route.name) {
          case 'Suggestion':
          case 'Inquiry':
            formData.append('contact', this.senderEmail);
            formData.append('contents', this.content);
            if (this.files.file) formData.append('files', this.files.file);
            this.sendMail(formData).then(response => {
              if (response.data) this.showSnackbar('메일을 발송했습니다.');
              this.loading = false;
              this.leave = true;
            }).catch(err => {
              console.error(err);
              this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
              this.loading = false;
            });
            break;
          case 'RefundRequest':
            this.requestPaymentCancel({
              idx: this.paymentIdx,
              tid: this.tid,
              cancelType: '',
              cancelMessage: this.content
            }).then(response => {
              if (response.data) this.showSnackbar('구매 취소를 요청했습니다.');
              this.loading = false;
              this.leave = true;
            }).catch(err => {
              console.error(err);
              this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
              this.loading = false;
            });
            break;
        }
      },
      onFileChanged (event) {
        let file = event.target.files[0];
        if (typeof file !== 'undefined' && /^image\//i.test(file.type)) this.readFile(file);
      },
      // image file read & process
      readFile (file) {
        let reader = new FileReader();
        let root = this;
        reader.onloadend = function () {
          root.appendFile(file.name, reader.result);
        };
        reader.onerror = function () {
          // alert('error');
          // root.showModal({ flag: true, which: `Alert#${root.$t('error')}` });
        };
        reader.readAsDataURL(file);
      },
      appendFile (filename, dataURL) {
        let blob = this.dataURItoBlob(dataURL);
        this.files = { name: filename, url: dataURL, file: blob };
      },
      dataURItoBlob (dataURI) {
        let byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      },
      deleteFile () {
        this.files = { name: '', url: null, file: null };
      },
      showSnackbar (message) {
        console.log(message);
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .button-style {
    height: 56px;
    font-size: 14px;
    letter-spacing: -0.3px;
  }

  /deep/ .v-input__slot {
    background-color: map_get($colors, background);
    border: 1px solid map_get($colors, background-shadow);
    border-radius: 5px;
    margin-bottom: 0;

    &:before {
      border-color: map_get($colors, background-shadow) !important;
    }

    .v-text-field__slot {
      .v-label {
        top: -8px;
      }
      input, textarea {
        font-size: 14px;
        letter-spacing: -0.3px;
        line-height: 20px;

        padding: 10px 16px;
        max-height: unset;
      }
    }

    .v-input__append-inner {
      margin-top: 10px;
      margin-right: 10px;
    }
  }

  /deep/ .v-text-field__details {
    margin-top: 8px;
  }



</style>
